import React from "react";

interface Props {
  couponCode: string;
  refCode: string;
  refreshQuoteWithoutCoupon: (e: any) => void;
}

const AppliedVoucher: React.FC<Props> = ({
  couponCode,
  refCode,
  refreshQuoteWithoutCoupon,
}) => {
  const code = couponCode || refCode;

  if (!code) return null;

  return (
    <div className="price-line voucher-applied">
      <span>Voucher ({code})</span>
      <button type="button" onClick={refreshQuoteWithoutCoupon}>
        Cancel
      </button>
    </div>
  );
};

export default AppliedVoucher;
